import { render, staticRenderFns } from "./VMostraPlacas.vue?vue&type=template&id=0230ad50&"
import script from "./VMostraPlacas.vue?vue&type=script&lang=js&"
export * from "./VMostraPlacas.vue?vue&type=script&lang=js&"
import style0 from "./VMostraPlacas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports